import { render, staticRenderFns } from "./CartItemList.vue?vue&type=template&id=6b340c45&"
import script from "./CartItemList.vue?vue&type=script&lang=ts&"
export * from "./CartItemList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports